module.exports = __webpack_public_path__ + "static/media/zakaria.7f5664e0.jpeg";